import { render } from "./ThreeFor700TestCard.vue?vue&type=template&id=f136f67a&scoped=true"
import script from "./ThreeFor700TestCard.vue?vue&type=script&lang=js"
export * from "./ThreeFor700TestCard.vue?vue&type=script&lang=js"

import "./ThreeFor700TestCard.vue?vue&type=style&index=0&id=f136f67a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f136f67a"]])

export default __exports__